import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../constants/path';
import { APP_NAME, STATIC_ROOT, HAS_LOGO, REDIRECT_LINK } from '../../constants';

import headerService from '../../services/header';

import { Logo } from '../icons/Logo';
import SearchComponent from './search/SearchComponent';
import LocalizedNavLink from '../router/LocalizedNavLink';

import { Header, HeaderGlobalStyle } from './HeaderComponentStyle';

class HeaderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stateOpenMenuMobileSlide: false
        };
    }

    onClickBtMenuMobile(e) {
        e.preventDefault();
        this.props.dispatch(
            headerService.actions.toggleMenuMobileSlide(
                headerService.constants.MENU_VERSION_MENU_MOBILE_SLIDE
            )
        );
    }

    render() {
        const { i18n, stateOpenMenuMobileSlide, versionOpenMenuMobileSlide } = this.props;

        return (
            <Header className="conteneur flex-container-h flex-center-alt">
                <HeaderGlobalStyle />

                {!isEmpty(REDIRECT_LINK) ? (
                    <a href={REDIRECT_LINK} className="logo">
                        <Logo />
                    </a>
                ) : (
                    <LocalizedNavLink to={PATH.HOME_PATH} title={APP_NAME} className="logo">
                        <Logo />
                    </LocalizedNavLink>
                )}
                <SearchComponent
                    stateOpenMenuMobileSlide={stateOpenMenuMobileSlide}
                    versionOpenMenuMobileSlide={versionOpenMenuMobileSlide}
                />
                {HAS_LOGO && (
                    <div className="poweredby">
                        <span>{i18n.POWERED_BY}</span>
                        <img
                            src={`${STATIC_ROOT}/logo-plebicom.png`}
                            alt="Plebicom"
                            width="79"
                            height="16"
                        />
                    </div>
                )}
                <button
                    className={`menu-mobile-bt menu-mobile-bt-listener show-mobonly ${
                        stateOpenMenuMobileSlide ? 'open' : ''
                    }`}
                    id="menu-mobile-bt"
                    data-target="menu"
                    onClick={this.onClickBtMenuMobile.bind(this)}>
                    <span />
                </button>
            </Header>
        );
    }
}

HeaderComponent.propTypes = {
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header,
        stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
        versionOpenMenuMobileSlide: state.header.versionOpenMenuMobileSlide
    };
}

export default connect(mapStateToProps)(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/header/HeaderComponent.js